import * as Components from '../components'
import * as Hooks from '../hooks'
import * as Navigation from '../navigation'
import { View } from 'tamagui'
import { router } from 'expo-router'
import { Routes as AppRoutes } from '@/src/common/enums/routes'
import { LoadingSpinner } from '@/src/common/components/LoadingSpinner'
import { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

export function ProcessingScreen() {
  const { status } = Hooks.useCardApplicationStatusWithRefresh()
  const isLargeViewport = useMediaQuery({ minWidth: 720 })

  useEffect(() => {
    switch (status) {
      case 'STATUS_PENDING':
      case 'STARTED':
      case 'SUBMITTING':
      case 'PROCESSING':
        return
      case 'NOT_FOUND':
      case 'ADMIN_RESET':
        // If the application is not found, redirect the user to the card benefits screen
        router.replace(AppRoutes.CardBenefits.route)
        return
      default: {
        const targetRoute = Navigation.ApplicationStatusRoutes[status].entryRoute
        router.replace(targetRoute.route)
      }
    }
  }, [status])

  return (
    <View flex={1} bg="$white1" pb="$8">
      <Components.ApplicationScreen>
        <Components.ApplicationScreen.Content
          title="Your application is processing"
          titleAlignment={isLargeViewport ? 'center' : 'left'}
        >
          <Components.FormHelpText text={isLargeViewport ? 'center' : 'left'}>
            It should only take a few seconds
          </Components.FormHelpText>
          <View flex={1} items="center" justify="center" my="$8">
            <LoadingSpinner />
          </View>
        </Components.ApplicationScreen.Content>
        <Components.ApplicationScreen.SubmitButton
          onPress={() => router.push(AppRoutes.Main.route)}
          title="Return Home"
        />
      </Components.ApplicationScreen>
    </View>
  )
}
